import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  theme: {
    tokens: {
      // Global font settings
      fonts: {
        heading: { value: "'Roboto', sans-serif" },
        body: { value: "'Roboto', sans-serif" }
      },
      // Global font size settings
      fontSizes: {
        sm: { value: '12px' },
        md: { value: '16px' },
        lg: { value: '20px' },
        xl: { value: '24px' }
      },
      // Global theme colors
      colors: {
        neutrals: {
          0: { value: '#FFFFFF' },
          50: { value: '#FAFAFA' },
          100: { value: '#F1F1F1' },
          200: { value: '#E7E7E7' },
          300: { value: '#D5D5D5' },
          500: { value: '#929292' },
          700: { value: '#545454' },
          800: { value: '#404040' },
          900: { value: '#242424' }
        },
        primary: {
          50: { value: '#F6F8FF' },
          100: { value: '#DBE4FF' },
          300: { value: '#CAD6FF' },
          500: { value: '#AFC1FF' },
          700: { value: '#829FFF' },
          900: { value: '#4E76FF' },
          1000: { value: '#3C5CC6' }
        },
        background: {
          primary: { value: '#F8F9FB' },
          secondary: { value: '#FFFFFF' },
          tertiary: { value: '#FAFAFA' },
          overlay: { value: '#242424' }
        },
        error: {
          100: { value: '#FEF3F2' },
          300: { value: '#FECDCA' },
          500: { value: '#F97066' },
          700: { value: '#D92D20' },
          900: { value: '#912018' }
        },
        warning: {
          100: { value: '#FFFAEB' },
          300: { value: '#FEDF89' },
          500: { value: '#FDB022' },
          700: { value: '#DC6803' },
          900: { value: '#93370D' }
        },
        success: {
          100: { value: '#ECFDF3' },
          300: { value: '#A6F4C5' },
          500: { value: '#32D583' },
          700: { value: '#039855' },
          900: { value: '#05603A' }
        },
        info: {
          100: { value: '#EDF7FC' },
          300: { value: '#A6D5F2' },
          500: { value: '#5EB3E8' },
          700: { value: '#1E91E6' },
          900: { value: '#14608F' }
        }
      }
    }
  }
});

export const system = createSystem(defaultConfig, config);
